import React, { useState, useEffect } from 'react';
import { auth, db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

function Menu() {
    const [username, setUsername] = useState("");
    const [role, setRole] = useState("");
    const [openMenus, setOpenMenus] = useState({});

    const toggleMenu = (menuKey) => {
        setOpenMenus(prev => ({
            ...prev,
            [menuKey]: !prev[menuKey]
        }));
    };

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (user) => {
            if (user) {
                try {
                    const docRef = doc(db, "users", user.uid);
                    const docSnap = await getDoc(docRef);
                    if (docSnap.exists()) {
                        const data = docSnap.data();
                        setUsername(data.username);
                        setRole(data.role);
                    }
                } catch (error) {
                    console.error("Error fetching user data: ", error);
                }
            }
        });

        return () => unsubscribe(); // Cleanup listener on unmount
    }, []);


    return (
        <div>
            <aside className="main-sidebar sidebar-dark-primary elevation-4">
                <a href="/" className="brand-link">
                    <img src={window.location.origin + '/user.jpg'} alt="A" className="brand-image img-circle elevation-3" style={{ opacity: '.8' }} />
                    <span className="brand-text font-weight-light">{username}</span>
                </a>

                <div className="sidebar">
                    <nav className="mt-2">
                        <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">

                            {/* Home */}
                            <li className="nav-item">
                                <a href="/home" className="nav-link">
                                    <i className="nav-icon fa fa-home" />
                                    <p>Home</p>
                                </a>
                            </li>

                            {/* Reservations Menu */}
                            <li className={`nav-item ${openMenus['reservations'] ? 'menu-open' : ''}`}>
                                <a href="#0" className="nav-link" onClick={() => toggleMenu('reservations')}>
                                    <i className="nav-icon fa fa-calendar" />
                                    <p>
                                        Reservations
                                        <i className="right fa fa-angle-left" />
                                    </p>
                                </a>
                                <ul className="nav nav-treeview" style={{ display: openMenus['reservations'] ? 'block' : 'none' }}>
                                    <li className="nav-item"><a href="/live-bookings" className="nav-link"><i className="fa fa-circle nav-icon" /><p>Live Bookings</p></a></li>
                                    <li className="nav-item"><a href="/checkout-history" className="nav-link"><i className="fa fa-circle nav-icon" /><p>Checkout History</p></a></li>
                                    <li className="nav-item"><a href="/pending-bookings" className="nav-link"><i className="fa fa-circle nav-icon" /><p>Pending Bookings Notes</p></a></li>
                                    <li className="nav-item"><a href="/damage-notes" className="nav-link"><i className="fa fa-circle nav-icon" /><p>Damage Notes</p></a></li>
                                </ul>
                            </li>

                            {/* Reports Menu */}
                            <li className={`nav-item ${openMenus['reports'] ? 'menu-open' : ''}`}>
                                <a href="#0" className="nav-link" onClick={() => toggleMenu('reports')}>
                                    <i className="nav-icon fa fa-file" />
                                    <p>
                                        Reports
                                        <i className="right fa fa-angle-left" />
                                    </p>
                                </a>
                                <ul className="nav nav-treeview" style={{ display: openMenus['reports'] ? 'block' : 'none' }}>
                                    <li className="nav-item"><a href="/room-type-wise-online-bookings" className="nav-link"><i className="fa fa-circle nav-icon" /><p>Room Type Wise Online</p></a></li>
                                    <li className="nav-item"><a href="/datewise-sale-report" className="nav-link"><i className="fa fa-circle nav-icon" /><p>Date Wise Sale</p></a></li>
                                    <li className="nav-item"><a href="/dcr-report" className="nav-link"><i className="fa fa-circle nav-icon" /><p>DCR Report</p></a></li>
                                    <li className="nav-item"><a href="/receptionist-report" className="nav-link"><i className="fa fa-circle nav-icon" /><p>Receptionist Report</p></a></li>
                                    <li className="nav-item"><a href="/all-booking-report" className="nav-link"><i className="fa fa-circle nav-icon" /><p>All Booking Report</p></a></li>
                                    <li className="nav-item"><a href="/paymode-wise-report" className="nav-link"><i className="fa fa-circle nav-icon" /><p>Payment Mode Wise</p></a></li>
                                    <li className="nav-item"><a href="/booking-type-report" className="nav-link"><i className="fa fa-circle nav-icon" /><p>Booking Type Wise</p></a></li>
                                    <li className="nav-item"><a href="/user-logs" className="nav-link"><i className="fa fa-circle nav-icon" /><p>User Logs</p></a></li>
                                    <li className="nav-item"><a href="/login-details" className="nav-link"><i className="fa fa-circle nav-icon" /><p>Login Details</p></a></li>
                                    <li className="nav-item"><a href="/user-mgmt" className="nav-link"><i className="fa fa-circle nav-icon" /><p>User Mgmt</p></a></li>
                                    <li className="nav-item"><a href="/approvals" className="nav-link"><i className="fa fa-circle nav-icon" /><p>Approvals</p></a></li>
                                </ul>
                            </li>

                            {/* OTA Mgmt Menu */}
                            <li className={`nav-item ${openMenus['ota'] ? 'menu-open' : ''}`}>
                                <a href="#0" className="nav-link" onClick={() => toggleMenu('ota')}>
                                    <i className="nav-icon fa fa-globe" />
                                    <p>
                                        OTA Mgmt
                                        <i className="right fa fa-angle-left" />
                                    </p>
                                </a>
                                <ul className="nav nav-treeview" style={{ display: openMenus['ota'] ? 'block' : 'none' }}>
                                    <li className="nav-item"><a href="/website-rooms" className="nav-link"><i className="fa fa-circle nav-icon" /><p>Website Rooms</p></a></li>
                                    <li className="nav-item"><a href="/website-gallery" className="nav-link"><i className="fa fa-circle nav-icon" /><p>Website Gallery</p></a></li>
                                </ul>
                            </li>

                            {/* Master Menu */}
                            <li className={`nav-item ${openMenus['master'] ? 'menu-open' : ''}`}>
                                <a href="#0" className="nav-link" onClick={() => toggleMenu('master')}>
                                    <i className="nav-icon fa fa-book" />
                                    <p>
                                        Master
                                        <i className="right fa fa-angle-left" />
                                    </p>
                                </a>
                                <ul className="nav nav-treeview" style={{ display: openMenus['master'] ? 'block' : 'none' }}>
                                    <li className="nav-item"><a href="/room-types" className="nav-link"><i className="fa fa-circle nav-icon" /><p>Room Types</p></a></li>
                                    <li className="nav-item"><a href="/room-type-images" className="nav-link"><i className="fa fa-circle nav-icon" /><p>Room Types Images</p></a></li>
                                    <li className="nav-item"><a href="/room-details" className="nav-link"><i className="fa fa-circle nav-icon" /><p>Room Details</p></a></li>
                                    <li className="nav-item"><a href="/rate-plans" className="nav-link"><i className="fa fa-circle nav-icon" /><p>Rate Plans</p></a></li>
                                    <li className="nav-item"><a href="/room-tarrif" className="nav-link"><i className="fa fa-circle nav-icon" /><p>Room Tarrifs</p></a></li>
                                    <li className="nav-item"><a href="/room-services" className="nav-link"><i className="fa fa-circle nav-icon" /><p>Room Services</p></a></li>
                                    <li className="nav-item"><a href="/payment-modes" className="nav-link"><i className="fa fa-circle nav-icon" /><p>Payment Modes</p></a></li>
                                    <li className="nav-item"><a href="/booking-types" className="nav-link"><i className="fa fa-circle nav-icon" /><p>Booking Types</p></a></li>
                                </ul>
                            </li>

                             <li className="nav-item">
                                <a href="/user-mgmt" className="nav-link">
                                    <i className="nav-icon fa fa-user" />
                                    <p>User Mgmt</p>
                                </a>
                            </li>

                        </ul>
                    </nav>
                </div>
            </aside>
        </div>
    );
}

export default Menu;
